import type { TParametrosRotinaArquivo } from '@/domain/simulador/factories/concrete/horizontal/sacocv/rotina-arquivo-base'

export const parametrosRotinaArquivo: TParametrosRotinaArquivo = {
  custoEmUPF: 0,
  dataPontoMedio: new Date().toISOString(),
  dataSaldo: new Date().toISOString(),
  margemGcom: 0,
  margemGR: 0,
  margemVendedor1Por3: 0,
  margemVendedor2Por3: 0,
  margemVendedor3Por3: 0,
  mascaraGcom: 0,
  mascaraGR: 0,
  mascaraVendedor: 0,
  ordemMascaraGcom: 0,
  ordemMascaraGR: 0,
  modoDeLucroDaEmpresa: 'IsencaoIRPJ',
  patrimonioAfetacao: false,
  ordemMascaraVendedor: 0,
  percentualAutonomiaVendedorSobrePoupanca1Por3: 0,
  percentualAutonomiaVendedorSobrePoupanca2Por3: 0,
  percentualComissaoVendedor: 0,
  percentualImpostos: 0,
  percentualIRPJ: 0,
  percentualISS: 0,
  percentualJurosAnualAntesPontoMedio: 0,
  percentualJurosAnualDepoisPontoMedio: 0,
  taxaUpf: 0,
}
